<template>
  <div class="free-study">
    <div class="tit-first">免费学习内容</div>
    <div class="tit-second">联合会员之外，惠得分联合三大平台提供免费学习内容</div>
    <div class="cards">
      <div class="card" :class="item.class" v-for="item in cardList" :key="item.id">
        <div class="card-top">
          <div class="left">
            <div class="title2">{{ item.title2 }}</div>
            <div class="free">免费版</div>
          </div>
          <div class="title1">{{ item.title1 }}</div>
        </div>
        <div class="card-content">{{ item.content }}</div>
        <div class="card-bottom">
          <div class="title3">{{ item.title3 }}</div>
          <div  class="feature">{{ item.feature1 }}</div>
          <div  class="feature">{{ item.feature2 }}</div>
          <div  class="feature">{{ item.feature3 }}</div>
          <div class="btntxt" @click="buy(item)">{{ item.btntxt }}</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>

const cardList = [
  {
    id: '001',
    class: 'one',
    title1: '智领',
    title2: '成长发展规划',
    content: '免费版提供普适学习内容，如需针对强化请购买联合会员',
    title3: '升级为智领会员版',
    feature1: '更多维度的测评量表',
    feature2: '海外院校库',
    feature3: '专业留学咨询服务',
    btntxt: '¥199购买智领会员'
  },
  {
    id: '002',
    class: 'two',
    title1: '智码',
    title2: '软件编程课程',
    content: '免费版提供普适学习内容，如需针对强化请购买联合会员',
    title3: '升级为智码会员版',
    feature1: '专业系列课程',
    feature2: '会员优势2',
    feature3: '会员优势3',
    btntxt: '¥199购买智码会员'
  },
  {
    id: '003',
    class: 'three',
    title1: '智习',
    title2: '智能学习中心',
    content: '免费版提供普适学习内容，如需针对强化请购买联合会员',
    title3: '升级为智习会员版',
    feature1: '会员优势1',
    feature2: '',
    feature3: '',
    btntxt: '¥199购买智习会员'
  },
]
const buy = (item) => {
  console.log(item.title1)
}
</script>

<style scoped>
.free-study {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.tit-first {
  font-size: 18px;
  font-weight: 900;
  color: #333333;
  border-bottom: 2px solid #333333;
  width: fit-content;
}
.tit-second {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.cards {
  display: flex;
  justify-content: space-between;
  gap: 60px;
}
.card {
  width: 320px;
}
.card-bottom {
  border: 2px solid;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0 10px 40px;
  flex: 1;
}
.card.one .card-bottom {
  border-color: #FF957F;
}
.card.two .card-bottom {
  border-color: #FFB45D;
}
.card.three .card-bottom {
  border-color: #F6D15B;
}
.feature {
  height: 24px;
}
.card.one .card-bottom .feature {
  color: #FF957F;
}
.card.two .card-bottom .feature {
  color: #FFB45D;
}
.card.three .card-bottom .feature {
  color: #F6D15B;
}
.btntxt {
  color: #fff;
  width: fit-content;
  text-align: center;
  border-radius: 4px;
  padding: 4px 10px;
  cursor: pointer;
}
.card.one .card-top,
.card.one .card-bottom .btntxt {
  background-color: #FF957F;
}
.card.two .card-top,
.card.two .card-bottom .btntxt {
  background-color: #FFB45D;
}
.card.three .card-top,
.card.three .card-bottom .btntxt {
  background-color: #F6D15B;
}

.card-top {
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  padding: 10px 20px;
  color: #fff;
}
.title1 {
  font-size: 34px;
  font-weight: 800;
  padding-top: 20px;
}
.free {
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #fff;
  border-radius: 4px;
  width: fit-content;
  padding: 2px 10px;
  margin-top: 10px;
}
.card-content {
  font-size: 10px;
  margin: 10px 0;
}
</style>
